module.exports = "/static/assets/458e9061efe7fcdc107bac0c7b823cc5.png";